import { render, staticRenderFns } from "./StravaButton.vue?vue&type=template&id=606ec3da&"
import script from "./StravaButton.vue?vue&type=script&lang=js&"
export * from "./StravaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports